import { svg } from "../svg";

const MavenInjectMark = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" fill="none" class="tw-text-fg-brand">
    <title>MavenInject</title>
    <path
      d="M18 94V34l30 30 30-30v60M78 94V34l30 30v30"
      stroke="var(--color-fg-brand)"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="11"
    />
  </svg>
`;

const MavenInjectLogo = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 160" fill="none" class="tw-text-fg-brand">
    <title>MavenInject</title>
    <path
      d="M28 116V44l38 38 38-38v72M104 116V44l38 38 38-38v72"
      stroke="var(--color-fg-brand)"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="12"
    />
    <text
      x="214"
      y="105"
      class="tw-fill-fg-heading"
      font-family="Inter, 'Segoe UI', sans-serif"
      font-size="64"
      font-weight="700"
      letter-spacing="-2"
    >MavenInject</text>
  </svg>
`;

const MavenInjectNavLogo = svg`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 160" fill="none" class="tw-text-fg-brand">
    <title>MavenInject</title>
    <path
      d="M28 116V44l38 38 38-38v72M104 116V44l38 38 38-38v72"
      stroke="var(--color-fg-brand)"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="12"
    />
    <text
      x="214"
      y="105"
      class="tw-fill-fg-nav"
      font-family="Inter, 'Segoe UI', sans-serif"
      font-size="64"
      font-weight="700"
      letter-spacing="-2"
    >MavenInject</text>
  </svg>
`;

export { MavenInjectMark, MavenInjectLogo, MavenInjectNavLogo };
